import { createSlice } from '@reduxjs/toolkit';
import ReduxStatus from '../../common/constants/ReduxStatus';
import { verifyConfirmEmailChange } from './thunk';


const initialState = {
    data: {},
    status: ReduxStatus.empty,
    errorMessages: []
};

export const updateEmailSlice = createSlice({
    name: 'updateEmail',
    initialState,
    reducers: {},
    extraReducers: {
        [verifyConfirmEmailChange.pending]: (state, action) => {
            state.status = ReduxStatus.loading;
        },
        [verifyConfirmEmailChange.fulfilled]: (state, action) => {
            state.data = action.payload;
            state.status = ReduxStatus.loaded;
        },
        [verifyConfirmEmailChange.rejected]: (state, action) => {
            state.errorMessages = action.payload;
            state.status = ReduxStatus.loadFailed;
        }
    }
});

export default updateEmailSlice.reducer;
